import * as React from 'react';
import { createContext, useCallback, useEffect, useRef, useState } from 'react';
import CollapsedButton from './components/collapsed-button';
import VirtualAssistantOpen from './components/virtual-assistant-open';
import './virtual-assistant.scss';

export const PartContext = createContext(null);

const VirtualAssistant = (props: any) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const open = useCallback(() => setIsOpen(true), []);
    const close = useCallback(() => setIsOpen(false), []);
    const latestOpen = useRef<boolean>();

    useEffect(() => {
        latestOpen.current = isOpen;
    }, [isOpen]);

    useEffect(() => {


        const openOnMessage = () => setIsOpen(true);

        window.addEventListener('openAssistant', openOnMessage);

        return () => {
            window.removeEventListener('openAssistant', openOnMessage);
        };
    }, []);

    useEffect(() => {
        const isOpenFromLs = (localStorage.getItem('virtualAssistantOpen') || false) === 'true';

        setIsOpen(isOpenFromLs);

        const saveToLS = () =>
            localStorage.setItem('virtualAssistantOpen', JSON.stringify(latestOpen.current));

        window.addEventListener('beforeunload', saveToLS);

        return () => {
            window.removeEventListener('beforeunload', saveToLS);
        };
    }, [latestOpen]);

    if (!props.config.isEnabled) return null;

    return (
        <PartContext.Provider
            value={{
                language: props.language,
                translations: props.translations,
                kbClientUrl: props.kbClientUrl,
                serviceUrl: props.serviceUrl,
                config: props.config,
            }}
        >
            {isOpen ? (
                <VirtualAssistantOpen
                    translations={props.translations}
                    close={close}
                />
            ) : (
                <CollapsedButton
                    translations={props.translations}
                    open={open}
                />
            )}
        </PartContext.Provider>
    );
};

export default VirtualAssistant;
